import React, { useEffect, useState } from "react";
import { CardModel } from "../models/card-model";
import { ResultVM } from "../models/Core/result-vm";
import { RowItem } from "../models/Core/row-item";
import * as app from "../services/AppService";
import * as http from "../services/http";
import Autocomplete from "./Autocomplete";
import Button from "./Button";
import Dialog from "./PublicDialogs/Dialog";
import Table from "./Table"; 
import { InterfaceComponentsProps } from "../models/Core/componentsCore";

interface CardSearchProps extends RowItem, Omit<InterfaceComponentsProps, "labelClass"|"isTable"> {
    filter?: string;
    onChange: (args: any) => any;
    afterSearch?: (args: any) => any;
    showTable?: boolean;
    required?: boolean;
    onFocus?: () => any;
    withOutSearch?: boolean;
    searchOnBlur?: boolean;
    iconClicked?: (...args: any) => any;
    placeholder?: string;
    model: CardModel;
}

interface SearchDataModel {
    model: any;
    autoOptions: any[];
    tableOptions: any[];
    showSimilarDialog: boolean;
    defaultString: string;
}
function CardSearch(props: CardSearchProps) {
    let options = app.options();
    const isAgent = +app.options().InterfaceType === 0;

    const [searchData, setSearchData] = useState<SearchDataModel>({
        model: props.model.ID,
        autoOptions: [],
        tableOptions: [],
        showSimilarDialog: false,
        defaultString: "",
    });

    useEffect(() => {
        setSearchData((old) => ({
            ...old,
            model: props.model.ID,
            defaultString: props.model.FirstName,
        }));
        if (+props.model.ID === 0 && props.model.FirstName === "")
            setSearchData((old) => ({ ...old, autoOptions: [], tableOptions: [] }));
    }, [props.model.FirstName, props.model.ID]);

    function getModel(Name: string = "") {
        return { ...new CardModel(Name), Card_Jop: props.model.Card_Jop };
    }

    function getCards(Name: string) {
        if (Name.length < 3) return;
        setSearchData((old) => ({
            ...old,
            defaultString: "",
        }));
        http.get("/Service/SearchCards", {
            Name, Filter: props.filter
        },(res: ResultVM) => {
                var Cards = res.AdditionalData;
                setSearchData((old) => ({
                    ...old,
                    defaultString: "",
                    autoOptions:
                        props.afterSearch || props.withOutSearch
                            ? Cards
                            : [
                                {
                                    Value: Name,
                                    Key: 0,
                                    Name,
                                },
                                ...Cards,
                            ],
                    tableOptions: Cards ? Cards : [],
                    showSimilarDialog:
                        +options.IsCentralBank === 1 && props.showTable === true,
                }));

                if (Cards.length === 0) {
                    if (props.withOutSearch) {
                        props.onChange && props.onChange(0);
                        return;
                    }
                    if (props.searchOnBlur) {
                        props.onChange(getModel(Name));
                        return;
                    }
                    if (props.afterSearch && typeof props.afterSearch == "function")
                        props.afterSearch(getModel(Name));
                    else props.onChange(getModel(Name));
                } else {
                    setSearchData((old) => ({ ...old, defaultString: "" }));
                    if (props.searchOnBlur) {
                        var elm = document.getElementById(props.id ? props.id : "auto" + props.label);
                        if (elm) {
                            elm.focus()
                        }
                    }
                }
            }
        );
    }

    function getCardByID(CardID: string, Obj: any) {
        if (props.withOutSearch) {
            props.onChange && props.onChange(CardID);
            return;
        }
        if (+CardID === 0) {
            const DefaultString = Obj.Name ? Obj.Name : Obj.Value;
            props.onChange(getModel(DefaultString));
            return;
        }
        if (+props.model.ID === +CardID || CardID === undefined) return; //, WithImage: false
        http.get(
            "/Service/GetCardByID",
            { CardID, WithImage: +(props.filter ? props.filter : 2) === 2 },
            (res: ResultVM) => {
                if (res.Success) {
                    props.onChange(res.AdditionalData);
                    setSearchData((old) => ({
                        ...old,
                        autoOptions: [Obj],
                        tableOptions: [],
                    }));
                }
                if (!res.CarryOnData) app.disblayError(res, true);
            }
        );
    }

    function onBlur(item: any) {
        if (
            props.searchOnBlur &&
            (!props.model.FirstName ||
                props.model.FirstName.trim() !== item.Value.trim())
        ) {
            setSearchData(old => ({ ...old, defaultString: item.Value }))
            setTimeout(() => getCards(item.Value), 100);
        }
        if (item.Value.trim() === "" && +props.model.ID > 0)
            props.onChange(props.withOutSearch?0:getModel());
    }

    function enterClicked(name: string) {

        getCards(name);
    }

    function rowClicked(item: { Key: string }) {
        setSearchData((old) => ({ ...old, showSimilarDialog: false }));
        getCardByID(item.Key, item);
    }
    return (
        <>
            <Autocomplete
                options={searchData.autoOptions}
                defaultValue={searchData.defaultString}
                model={searchData.model}
                label={props.label}
                disabled={props.disabled}
                required={props.required}
                onChange={getCardByID}
                onEnterClicked={enterClicked}
                onFocus={props.onFocus}
                icon={props.icon || "search"}
                iconClicked={(item) => {
                    if (props.iconClicked)
                        props.iconClicked()
                    else
                        enterClicked(item.Value);
                }}
                onBlur={onBlur}
                placeHolder={props.placeholder}
                id={props.id}
                showNewWord={isAgent}
            />
            <Dialog
                show={searchData.showSimilarDialog}
                title="FrmSimilarOperat"
                size="lg"
                onClose={() => {
                    setSearchData((old) => ({ ...old, showSimilarDialog: false }));
                }}
            >
                <Table
                    data={searchData.tableOptions}
                    hidePagination
                    hideTotalCount
                    containerClass=" tableWrap-sm"
                    rowClicked={rowClicked}
                    cols={["BeneficiaryName", "Phone", "Address", "Select"]}
                    rows={[
                        "Value",
                        "Additional",
                        "AdditionalInfo",
                        (item: any) => (
                            <Button isTable label="Select" clicked={(e) => rowClicked(item)} />
                        ),
                    ]}
                />
            </Dialog>
        </>
    );
}

CardSearch.defaultProps = {
  filter: 2,
  disabled: false,
  required: false,
};

export default CardSearch;